import {
  Timestamp,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  setDoc,
  where
} from "firebase/firestore";
import { collectionData, docData } from "rxfire/firestore";
import { tap } from "rxjs/operators";
import { store } from "../";
import { notification$, totaltransaction$ } from "../redux/action";
import { db } from "./firebase";

import {NumericFormat} from "react-number-format";

const current_timestamp = Timestamp.fromDate(new Date());

export const CurrencyFormat = ({ amount, prefix, seperator }) => {
  return (
    <NumericFormat
      thousandSeparator={seperator}
      displayType={"text"}
      prefix={prefix}
      value={amount}
      decimalScale={2}
      fixedDecimalScale
    />
  );
};

export const CryptoCurrencyFormat = ({ amount, suffix }) => {
  return (
    <NumericFormat
      thousandSeparator={false}
      displayType={"text"}
     // suffix={suffix}
      value={amount}
      decimalScale={3}
      fixedDecimalScale
    />
  );
};

export const addUsers = async (docid, userdatas) => {
  const querydoc = doc(db, `users/${docid}`);
  await setDoc(querydoc, userdatas, { merge: true });
};

export const creditWallet = async (userid, wallet, data) => {
  const querydoc = doc(db, "users", `${userid}`, "wallet", wallet);
  await setDoc(querydoc, data, { merge: true });
};

export const getUserInfo = (userid) => {
  const querydoc = doc(db, `users/${userid}`);
  return docData(querydoc);
};

export const getTransactions = (userid) => {
  const transactionref = query(
    collection(db, "users", `${userid}`, "transactions"),
    where("main", "==", true)
  );
  return collectionData(transactionref, { idField: "uid" })
    .pipe(
      tap((transactions) => console.log("This is all transaction observable!"))
    )
    .subscribe((trans) => {
      console.log(trans.length);
      store.dispatch(totaltransaction$(trans.length));
    });
};

export const getTransactionsType = async (userid, coinType) => {
  const transactionref = query(
    collection(db, "users", `${userid}`, "transactions"),
    where("cointitle", "==", coinType),
    orderBy("timestamp", "desc")
  );
  const querySnapshot = await getDocs(transactionref);
  return querySnapshot;
};

export const addTransfer = async (userid, data) => {
  const docRef = doc(collection(db, "users", userid, "transactions"));

  return await setDoc(docRef, { ...data, timestamp: current_timestamp });
};

export const updateUserBalance = (userid, cointype, balance) => {
  const querydoc = doc(db, `users/${userid}`);
  console.log(balance);
  return setDoc(querydoc, { [cointype]: Number(balance) }, { merge: true });
};

export const getallusers = () => {
  const collectionRef = collection(db, "users");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const getuserDataAdmin = (id) => {
  const davidDocRef = doc(db, `users/${id}`);
  return docData(davidDocRef, { idField: "uid" });
};

export const getuserDataBalanceAdmin = (id, type) => {
  const DocRef = doc(db, "users", `${id}`, "account", type);
  return docData(DocRef, { idField: "uid" });
};

export const updateuserDataBalanceAdmin = (id, type, balance) => {
  const DocRef = doc(db, "users", `${id}`, "account", type);
  setDoc(DocRef, { balance: parseInt(balance) }, { merge: true });
  alert("User info has been updated successfully");
};

export const activateAccount = async (uid, current) => {
  const DocRef = doc(db, "users", `${uid}`);
  await setDoc(
    DocRef,
    { activated: current, Verificationstatus: current },
    { merge: true }
  );
};

export const getallWalletTransaction = () => {
  const collectionRef = collection(db, "transactionswallet");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const getallUserTrans = (id) => {
  const collectionRef = collection(db, "users", id, "transactions");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const addNotification = async (id, title, message) => {
  const DocRef = doc(collection(db, "users", `${id}`, "notification"));
  await setDoc(DocRef, { title: title, message: message });
};

export const getNotification = (id) => {
  const notificationRef = query(
    collection(db, "users", `${id}`, "notification")
  );
  return collectionData(notificationRef, { idField: "uid" }).subscribe(
    (data) => {
      store.dispatch(notification$(data));
    }
  );
};

export const deletedocument = async (id) => {
  await deleteDoc(doc(db, "users", id));
};

export const sendMessage = (message, subject, email, name) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify({
    message: message,
    to: `anthonyerics84@gmail.com, ${email}`,
    subject: subject,
    name: name,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch(
    "https://expresspage.vercel.app/winvault",
    requestOptions
  ).then((response) => response.text());
};

/** USD balance → crypto amount using a CoinGecko-style USD price */
export const toCoinAmount = (usdBalance, usdPrice) => {
  const price = Number(usdPrice);
  if (!price) return 0;
  return Number(usdBalance) / price;
};

/** Crypto amount → USD using a CoinGecko-style USD price */
export const toUsdAmount = (coinAmount, usdPrice) => {
  return Number(coinAmount) * Number(usdPrice || 0);
};

/** Native gas-token USD price for a network, from wallet list */
export const getNetworkGasPrice = (
  network,
  wallets = [],
  fallbackPrice = 0
) => {
  if (network === "Polygon") {
    const poly = wallets.find(
      (c) => c.network === "Polygon" && c.networkprice
    );
    return Number(poly?.networkprice || fallbackPrice || 0);
  }
  const codeByNetwork = {
    TRC20: "TRX",
    BEP20: "BNB",
    BTC: "BTC",
    Solana: "SOL",
    Avax: "AVAX",
    Arbitrum: "ARB",
    ERC20: "ETH",
  };
  const code = codeByNetwork[network] || "ETH";
  const coin = wallets.find((c) => c.code === code);
  return Number(coin?.price || fallbackPrice || 0);
};

export const getWhatsapp = async () => {
  const querydoc = doc(db, `whatsapp/number`);
  const data = await getDoc(querydoc);
  return data.data();
};
